const state = {
    recordDetail: {},
};
const mutations = {
    SET_RECORD_DETAIL: (state, data) => {
        state.recordDetail = data;
    },

    CLEAN_RECORD_ALL: (state) => {
        state.recordDetail = {};
    },
};
const actions = {
    /**
     * 保存预约记录
     * @param {Object} param
     * @param {Object} data
     * @returns {Promise}
     */
    setRecordDetailInfo({ commit }, data) {
        return new Promise((resolve) => {
            commit("SET_RECORD_DETAIL", data);
            resolve();
        });
    },

    /**
     * 移除预约记录
     * @param {Object} param0
     */
    removeRecordDetailInfo({ commit }) {
        commit("CLEAN_RECORD_ALL");
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
